import styled from 'styled-components'
import theme from 'theme_'

export interface LoaderOverlayProps {
  isFullScreen?: boolean
  isSemiTransparent?: boolean
}

export const StyledLoaderOverlay = styled.div<LoaderOverlayProps>`
  position: ${(p) => (p.isFullScreen ? 'fixed' : 'absolute')};
  z-index: ${theme.zIndex.loaderOverlay};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(p) =>
    p.isSemiTransparent ? theme.overlay.modalCommon : theme.colors.grey};
`

export interface SpinnerContainerProps {
  mt?: string
  size?: string
}

export const CenteredContainer = styled.div<SpinnerContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  ${(p) =>
    p.mt &&
    `
    margin-top: ${p.mt};
  `};
  ${(p) =>
    p.size &&
    `
    width: ${p.size}px;
    height: ${p.size}px;
  `};
`

export const CommonSpinedWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const StyledCompanyImage = styled.img`
  animation: ${theme.animations.flicker} 2s infinite;
`
